import React from 'react';
import { Box } from '@mui/material';
import { LOTTIE_ICONS } from '@/DesignSystem/features/lottie/lottie-icons';
import LottieIconComponent from '@/DesignSystem/features/lottie/LottieIconComponent';

const AIAssistantIcon = ({ width = 24, height = 24, onClick, isMarvin = true, ...props }) => {
    return (
        <Box onClick={onClick} {...props}>
            <LottieIconComponent
                icon={isMarvin ? LOTTIE_ICONS.MARVIN : LOTTIE_ICONS.JARVIS}
                width={width}
                height={height}
            />
        </Box>
    );
};

export default AIAssistantIcon;
